import styled from "styled-components"
import Title from "../../../common/Title"
import Division from "../../../common/Division"
import SkillBox from "../../../common/SkillBox"
import Content from "../../../common/Content"
import Accordion from "../../../common/Accordion"
import ListItem from "../../../common/ListItem"
import ProjectLinkBox from "../../../common/ProjectLinkBox"
import ProjectLink from "../../../common/ProjectLink"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHouse } from "@fortawesome/free-solid-svg-icons"
import { faGithub } from "@fortawesome/free-brands-svg-icons"

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export default function NovelcutBox() {

  return (
    <Box>
      <Title>웹소설 연재 사이트, NOVELCUT</Title>
      <Division>개인 프로젝트</Division>
      <SkillBox skill={[
        { logo: 'React', content: '리액트(React)', color: '61DAFB', },
        { logo: 'styledcomponents', content: 'Styled-components', color: 'DB7093', },
        { logo: 'JavaScript', content: '자바스크립트(JavaScript)', color: 'F7DF1E', division: true },
        { logo: 'nodedotjs', content: 'Node.js', color: '339933' },
        { logo: 'firebase', content: 'Firebase(재배포)', color: 'FFCA28', division: true },
        { logo: 'Mysql', content: 'MySQL', color: '4479A1' },
        { logo: 'firebase', content: 'Firebase FireStore(재배포)', color: 'FFCA28' },
      ]} />
      <Content>
        <Accordion title="개요" open={true}>
          NOVELCUT(노벨컷) 은 사용자가 직접 웹소설을 작성하고 공유할 수 있는 연재 플랫폼입니다. 네이버웹툰의 컷툰 서비스처럼 컷 형식 보기 방식을 도입했습니다.
        </Accordion>
        <Accordion title="주요 기능 및 역할" open={true}>
          <ListItem>소설 생성 및 회차 연재 기능을 제공합니다.</ListItem>
          <ListItem>컷 형식 보기 기능을 제공합니다.</ListItem>
          <ListItem>제목, 작가명 검색 기능을 제공하니다.</ListItem>
          <ListItem>최신순, 인기순(조회수)으로 소설 작품을 정렬해 제공합니다.</ListItem>
          <ListItem>Context API를 통한 전역 상태 관리합니다.</ListItem>
          <ListItem>JWT, Bcrypt를 통한 회원가입 및 인증 기능을 구현했습니다.</ListItem>
          <ListItem>CLOUDTYPE, Firebase(재배포) 서비스를 이용하여 배포했습니다.</ListItem>
          <ListItem>AWS S3 또는 Firebase Storage를 통한 이미지 업로드 기능을 제공합니다.</ListItem>
        </Accordion>
      </Content>
      <ProjectLinkBox>
        <ProjectLink href="https://novelcut-1f6f2.web.app/" title="Home">
          <FontAwesomeIcon icon={faHouse} />
        </ProjectLink>
        <ProjectLink href="https://github.com/Leewonno/project3" title="Github">
          <FontAwesomeIcon icon={faGithub} />
        </ProjectLink>
      </ProjectLinkBox>
    </Box>
  )
}

